import $ from 'jquery';
import 'slick-carousel';

document.querySelectorAll('.stage4d__container').forEach((stage) => {
	$(stage).slick({
		dots: true,
		fade: true,
		arrows: false,
		rows: 0,
		slidesToShow: 1,
		slidesToScroll: 1,
		infinite: false,
		responsive: [
			{
				breakpoint: 1067,
				settings: {
					dots: false
				}
			}
		]
	});
})


